<template>
  <Link
    class="flex items-center gap-3 text-on-surface cursor-pointer py-4 px-3 elevation-1 surface1 rounded-xl transition-all duration-300 hover:transition-all hover:duration-300 hover:elevation-2 hover:surface2"
    :href="url"
  >
    <Icon
      v-if="icon"
      :name="icon"
      class="w-fit shrink-0 text-primary20 fill-primary20"
      width="3em"
      height="3em"
    />
    <div class="flex flex-col cursor-pointer">
      <label class="title-md text-on-surface-variant">{{ subtitle }}</label>
      <label class="title-lg text-on-surface font-medium">{{ title }}</label>
    </div>
  </Link>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue'
import Icon from '@/Components/Icon'

export default {
  name: 'LinkCard',
  components: { Icon, Link },
  props: {
    subtitle: String,
    title: String,
    icon: String | Boolean,
    url: String,
  },
}
</script>
